import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import { store } from "./redux/store.js";

import ReactGA from "react-ga4";

if (process.env.REACT_APP_ENABLE_GA4 === "true") {
  // Se inicializa el objeto de analytics para el sitio
  ReactGA.initialize(process.env.REACT_APP_ACCESORIOS_GA_ID);
}

ReactDOM.render(
  //<React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  //</React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
